import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "control__placeholder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaskInput = _resolveComponent("MaskInput")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["control__wrapper", [
      `control--${_ctx.skin}`,
      (_ctx.modelValue.length > 0 || _ctx.isFocus) && 'control__wrapper--focus',
    ]])
  }, [
    (!_ctx.isPhone)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
          class: "control__control",
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
        }, null, 544)), [
          [_vModelText, _ctx.model]
        ])
      : (_openBlock(), _createBlock(_component_MaskInput, {
          key: 1,
          modelValue: _ctx.model,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model) = $event)),
          class: "control__control",
          onFocus: _ctx.onFocus,
          onBlur: _ctx.onBlur,
          mask: "+###########"
        }, null, 8, ["modelValue", "onFocus", "onBlur"])),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.placeholder), 1)
  ], 2))
}